var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M8.314 1C4.297 1 1.04 4.131 1.04 7.993c0 3.861 3.258 6.993 7.275 6.993s7.275-3.132 7.275-6.993S12.332 1 8.314 1m0 12.8c-3.335 0-6.04-2.601-6.04-5.807s2.705-5.807 6.04-5.807 6.04 2.6 6.04 5.807c0 3.206-2.704 5.806-6.04 5.806"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M7.535 5.246c0 .198.082.389.228.53.146.14.344.219.551.219a.8.8 0 0 0 .551-.22.74.74 0 0 0 .229-.53.74.74 0 0 0-.229-.53.8.8 0 0 0-.55-.219.8.8 0 0 0-.552.22.74.74 0 0 0-.228.53m1.169 1.748h-.78a.13.13 0 0 0-.13.125v4.245c0 .07.059.125.13.125h.78c.071 0 .13-.056.13-.125V7.12a.13.13 0 0 0-.13-.125"
  })));
};
export default SvgInfo;